import { Button, ButtonProps } from '@lfg/ui/components';

import { colors } from 'src/global/styles/colors';

export function DestructiveButton({ children, sx, ...rest }: ButtonProps) {
  return (
    <Button
      bgColor={colors.red300}
      borderRadius={'4px'}
      sx={{
        padding: '14px 32px',
        display: 'flex !important',
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
        '&:disabled': {
          color: 'white',
          opacity: 0.3,
          cursor: 'not-allowed',
        },
        '&:hover': {
          backgroundColor: '#F25F3D',
        },
        ...sx,
      }}
      variant='contained'
      fullWidth
      {...rest}>
      {children}
    </Button>
  );
}
